import { render, staticRenderFns } from "./TraceabilityPanel.vue?vue&type=template&id=164a9486"
import script from "./TraceabilityPanel.vue?vue&type=script&lang=js"
export * from "./TraceabilityPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports